import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchDcmCampaigns, selectCampaignId } from "../actions/dcm/campaigns";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

const useStyles = makeStyles((theme) => ({
  searchSelect: {
    zIndex: 5,
    maxWidth: 800
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  }
}));

export default function CampaignSelect() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const campaigns = useSelector((state) => state.dcmCampaigns);

  useEffect(() => {
    dispatch(fetchDcmCampaigns());
  }, [dispatch]);

  return (
    <Select
      className={classes.searchSelect}
      options={campaigns.data}
      isLoading={campaigns.isLoading}
      value={campaigns.byId[campaigns.selectedId]}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      placeholder="Select Campaign"
      onChange={(e) => dispatch(selectCampaignId(e.id))}
    />
  );
}
